import CSS from 'csstype';
import React from 'react';

import {
  ActivityIcon,
  AlertIcon,
  ArrowIcon,
  AvailableIcon,
  BiddersIcon,
  CalendarIcon,
  CaretIcon,
  ChannelsIcon,
  CheckmarkPlainIcon,
  ClockIcon,
  CloseIcon,
  CodeIcon,
  CollapseIcon,
  ColumnsIcon,
  CompassIcon,
  CubeIcon,
  CustomizeIcon,
  DeleteIcon,
  DownloadIcon,
  EmailIcon,
  ExpandIcon,
  ExternalLinkIcon,
  EyeIcon,
  EyeOffIcon,
  FilterIcon,
  FlagIcon,
  FlameIcon,
  FlashIcon,
  GlobeIcon,
  HamburgerIcon,
  HandshakeIcon,
  ImageIcon,
  InfoIcon,
  InfoStaticIcon,
  LayersIcon,
  LightBulbIcon,
  LinkIcon,
  LoaderIcon,
  LogInIcon,
  MessageIcon,
  MonitorIcon,
  NewIcon,
  PaperPlaneIcon,
  PersonesIcon,
  PlayIcon,
  PriceTagIcon,
  RefreshIcon,
  RepeatIcon,
  SaveIcon,
  ScheduleIcon,
  SendIcon,
  SettingsIcon,
  ShoppingIcon,
  SuccessCheckMarkIcon,
  SwapIcon,
  SyncIcon,
  TimerIcon,
  TrendUpIcon,
  UnavailableIcon,
  VectorIcon,
  VennIcon,
} from '~/src/dash/components/icons/IconV2/icons';
import { fontColorsDefault } from '~/src/dash/components/layout/common';

interface IIconV2Props {
  className?: string;
  color?: string;
  large?: boolean;
  name: string;
  small?: boolean;
  style?: CSS.Properties;
}

export const IconV2 = ({
  className = '',
  color = fontColorsDefault.base,
  large,
  name,
  small,
  style,
}: IIconV2Props) => {
  // keep this alphabetized
  switch (name) {
    case 'activity':
      return (
        <ActivityIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'alert':
      return (
        <AlertIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'arrow':
      return (
        <ArrowIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'available':
      return (
        <AvailableIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'bidders':
      return <BiddersIcon small={small} color={color} style={style} className={className} />;

    case 'caret':
      return (
        <CaretIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'clock':
      return (
        <ClockIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'calendar':
      return (
        <CalendarIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'channels':
      return <ChannelsIcon small={small} color={color} style={style} className={className} />;

    case 'checkmark-plain':
      return (
        <CheckmarkPlainIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'close':
      return (
        <CloseIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'code':
      return (
        <CodeIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'collapse':
      return (
        <CollapseIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'columns':
      return (
        <ColumnsIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'compass':
      return (
        <CompassIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'cube':
      return (
        <CubeIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'customize':
      return (
        <CustomizeIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'delete':
      return (
        <DeleteIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'download':
      return (
        <DownloadIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'email':
      return (
        <EmailIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'expand':
      return (
        <ExpandIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'externalLink':
      return (
        <ExternalLinkIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'eye':
      return (
        <EyeIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'eyeoff':
      return (
        <EyeOffIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'filter':
      return (
        <FilterIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'flag':
      return (
        <FlagIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'flame':
      return (
        <FlameIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'flash':
      return (
        <FlashIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'globe':
      return (
        <GlobeIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'handshake':
      return <HandshakeIcon small={small} color={color} style={style} className={className} />;

    case 'hamburger':
      return <HamburgerIcon small={small} color={color} style={style} className={className} />;

    case 'info':
      return <InfoIcon small={small} color={color} style={style} className={className} />;

    case 'info-static':
      return (
        <InfoStaticIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'image':
      return <ImageIcon small={small} color={color} style={style} className={className} />;

    case 'layers':
      return (
        <LayersIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'light-bulb':
      return (
        <LightBulbIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'link':
      return (
        <LinkIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'loader':
      return (
        <LoaderIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'log-in':
      return <LogInIcon small={small} color={color} style={style} className={className} />;

    case 'message':
      return (
        <MessageIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'monitor':
      return <MonitorIcon small={small} color={color} style={style} className={className} />;

    case 'new':
      return <NewIcon small={small} color={color} style={style} className={className} />;

    case 'paper-plane':
      return (
        <PaperPlaneIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'persones':
      return (
        <PersonesIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'play':
      return <PlayIcon small={small} color={color} style={style} className={className} />;

    case 'price-tag':
      return (
        <PriceTagIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'refresh':
      return (
        <RefreshIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'repeat':
      return <RepeatIcon small={small} color={color} style={style} className={className} />;

    case 'save':
      return (
        <SaveIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'schedule':
      return (
        <ScheduleIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'save':
      return (
        <SaveIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'send':
      return (
        <SendIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'settings':
      return (
        <SettingsIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'shopping':
      return (
        <ShoppingIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'success-check-mark':
      return (
        <SuccessCheckMarkIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'sync':
      return (
        <SyncIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'swap':
      return (
        <SwapIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'timer':
      return (
        <TimerIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'trend-up':
      return (
        <TrendUpIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'unavailable':
      return (
        <UnavailableIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'vector':
      return (
        <VectorIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'venn':
      return (
        <VennIcon small={small} large={large} color={color} style={style} className={className} />
      );

    default:
      return <div />;
  }
};
